<div class="carousel-item">
  <div class="card">
    <div class="card-header">
      <div class="card-header-label">{{ 'withdrawal' | translate }}</div>
      <div class="card-header-value">
        <cs-currency-converter [amount]="item.amount" [currency]="item.currency" />
        <cs-currency-unit-display [style.marginLeft.px]="10" [currency]="item.currency" />
      </div>
    </div>
    <div class="card-body">
      <div class="cell">
        <div class="card-body-label">{{ 'status' | translate }}</div>
        <div class="card-body-value alert">
          {{ item.statusName }}
          <!-- {{ enableCancelStatus.includes(item.status) ? 'Under Review' : 'Processing' }} -->
        </div>
      </div>
      <div class="cell">
        <div class="card-body-label">{{ 'id' | translate }}</div>
        <div class="card-body-value">{{ item.txid || item.orderNum || '-' }}</div>
      </div>
      <div class="cell">
        <div class="card-body-label">{{ 'platform_fee' | translate }}</div>
        <div class="card-body-value alert">
          <cs-currency-converter [amount]="item.fee" [currency]="item.currency" />
          <cs-currency-unit-display [style.marginLeft.px]="10" [currency]="item.currency" />
        </div>
      </div>
      @if (item.coinNetworkFee !== undefined && item.coinNetworkFee !== null) {
        <div class="cell">
          <div class="card-body-label">{{ 'network_fee' | translate }}</div>
          <div class="card-body-value alert">
            <cs-currency-converter [amount]="item.coinNetworkFee" [currency]="item.currency" />
            <cs-currency-unit-display [style.marginLeft.px]="10" [currency]="item.currency" />
          </div>
        </div>
      }
      <div class="cell">
        <div class="card-body-label">{{ 'received_amount' | translate }}</div>
        <div class="card-body-value success">
          <cs-currency-converter
            [amount]="item.amount - item.fee - (item.coinNetworkFee || 0)"
            [currency]="item.currency"
          />
          <cs-currency-unit-display [style.marginLeft.px]="10" [currency]="item.currency" />
        </div>
      </div>
    </div>
    <div class="card-footer">
      <cs-button
        [label]="'cancel_withdrawal_request' | translate"
        color="secondary"
        [disabled]="!item.enableCancelStatus?.includes(item.status)"
        (buttonClick)="item.onOpenCancel(item)"
      ></cs-button>
    </div>
  </div>
</div>
